import React from "react";
import { Typography, List, ListItem, ListItemText } from "@mui/material";

const ConditionsForValidity: React.FC = () => {
  // const conditions = [
  //   "The submitted details are correct and accurate.",
  //   "You will be able to provide add 2 Co-applicants with good credit in the Loan Structure.",
  //   "You will need to supply further information and documents for the final review and issuance of Sanction Letter.",
  //   "The final offer is subject to acceptance or rejection based on the review of your details and document.",
  // ];

  const conditions = [
    "The In-principle sanction is provisional in nature, based on the information shared by you and is subject to revision basis verification of documents and further assessment/review.",
    "The In-principle sanction letter is subject to revision basis the credit underwriting norms, policies of Avanse and upon change in any information provided by you in the application form.",
    "The ROI / Processing Fees is subject to revision in terms of the final sanction letter /loan agreement basis verification of your profile / security or otherwise.",
    "The final sanction may be issued to you upon satisfactory (i) credit assessment (ii) KYC requirement (ii) Clearance of due diligence process (iii) payment of processing fees and (iv) your meeting the eligibility criteria set by Avanse Financial Services Ltd., under its credit policy.",
    "This In-principle sanction will automatically expire within 6 days from the date hereof and does not create any binding obligations on Avanse Financial Services Ltd., to sanction the loan and the same may be revoked or cancelled as per Avanse’s discretion.",
  ];

  return (
    <div className="poContainer">
      <Typography className="text5lable">Terms & Conditions</Typography>
      <List dense sx={{ listStyleType: "decimal", pl: 2 }}>
        {conditions.map((condition, index) => (
          <ListItem
            key={index}
            className="inner-form-heading3"
            sx={{ display: "list-item", alignItems: "flex-start", mb: '0px !important' }}
          >
            <ListItemText primary={condition} className="inner-form-heading3" />
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default ConditionsForValidity;
